



// import React, { useState, useEffect } from "react";

// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;



//       const prompt = `
//         You are an expert front-end developer. Your task is to convert the provided UI/UX image into a single HTML file with embedded CSS.

//         The final output MUST be a single JSON object. The JSON object should contain two keys:
//         1.  "html": The complete and functional HTML code.
//         2.  "css": The complete CSS code.

//         Do NOT include any text before or after the JSON object. The response must be a valid JSON object.

//         Use the following framework and instructions:
//         - Framework: ${selectedFramework}
//         - Instructions: ${customPrompt || "Keep the design clean and as close to the image as possible."}

//         Make sure the code is production-ready, well-structured, and semantically correct.
//       `;

//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       // Extract JSON object from the raw text response
//       const jsonStart = rawText.indexOf('{');
//       const jsonEnd = rawText.lastIndexOf('}') + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>
//           <img
//             src="https://i.ibb.co/L5r64d7/ui-ux-design-placeholder-image.png"
//             alt="UI/UX Placeholder"
//             style={{ maxWidth: "100%", height: "auto" }}
//             className="rounded"
//           />
//         </div>
//       );
//     }

//     const fullHTML = `
//       <!DOCTYPE html>
//       <html lang="en">
//       <head>
//         <title>UI Preview</title>
//         <style>${generatedCSS}</style>
//         ${
//           selectedFramework === "bootstrap"
//             ? '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">'
//             : selectedFramework === "tailwind"
//             ? '<script src="https://cdn.tailwindcss.com"></script>'
//             : ""
//         }
//       </head>
//       <body>
//         ${generatedHTML}
//       </body>
//       </html>
//     `;

//     return (
//       <iframe
//         title="UI Preview"
//         srcDoc={fullHTML}
//         style={{
//           width: "100%",
//           height: "500px",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//         }}
//       />
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to{" "}
//               <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h5>Live Preview</h5>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//           {generatedHTML && (
//             <div className="card shadow-sm p-4 mt-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="css-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#css-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="css-code"
//                     aria-selected="false"
//                   >
//                     CSS
//                   </button>
//                 </li>
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//                 <div
//                   className="tab-pane fade"
//                   id="css-code"
//                   role="tabpanel"
//                   aria-labelledby="css-tab"
//                 >
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedCSS}</code>
//                   </pre>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//          <style jsx>{`
//         .youtube-thumbnail-generator {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 20px;
//         }

//         .credits-display {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .buy-credits-btn {
//           background-color: #4285f4;
//           color: white;
//           border: none;
//           padding: 5px 10px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .error-message {
//           color: #d32f2f;
//           background-color: #ffebee;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .success-message {
//           color: #388e3c;
//           background-color: #e8f5e9;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .main-content {
//           display: flex;
//           gap: 30px;
//           margin-bottom: 40px;
//         }

//         .form-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .form-group {
//           margin-bottom: 15px;
//         }

//         label {
//           display: block;
//           margin-bottom: 5px;
//           font-weight: bold;
//         }

//         input[type="text"],
//         select,
//         textarea {
//           width: 100%;
//           padding: 8px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           box-sizing: border-box;
//         }

//         .enhance-btn {
//           background-color: #fbbc05;
//           color: #333;
//           border: none;
//           padding: 8px 12px;
//           border-radius: 4px;
//           cursor: pointer;
//           margin-top: 8px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhance-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .form-actions {
//           display: flex;
//           gap: 10px;
//           margin-top: 20px;
//         }

//         .generate-btn,
//         .reset-btn {
//           padding: 10px 15px;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-weight: bold;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .generate-btn {
//           background-color: #ea4335;
//           color: white;
//           flex: 1;
//         }

//         .generate-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .reset-btn {
//           background-color: #f1f1f1;
//           color: #333;
//         }

//         .loading-spinner {
//           display: inline-block;
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: white;
//           animation: spin 1s ease-in-out infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         .preview-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .preview-container {
//           margin-bottom: 20px;
//         }

//         .generated-thumbnails {
//           display: flex;
//           flex-direction: column;
//           gap: 20px;
//         }

//         .thumbnail-item {
//           text-align: center;
//         }

//         .thumbnail-image {
//           max-width: 100%;
//           border-radius: 4px;
//           margin-bottom: 10px;
//         }

//         .download-btn {
//           background-color: #34a853;
//           color: white;
//           border: none;
//           padding: 8px 15px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .preview-placeholder {
//           text-align: center;
//           padding: 20px;
//         }

//         .thumbnail-frame {
//           width: 100%;
//           aspect-ratio: 16/9;
//           background-color: #333;
//           border-radius: 4px;
//           margin-top: 15px;
//           position: relative;
//           overflow: hidden;
//         }

//         .thumbnail-content {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           color: white;
//           padding: 20px;
//           box-sizing: border-box;
//         }

//         .thumbnail-title {
//           font-size: 24px;
//           font-weight: bold;
//           text-align: center;
//           color: #ff0000;
//           text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//         }

//         .preview-info {
//           margin-top: 20px;
//         }

//         .prompt-preview {
//           background-color: #e0e0e0;
//           padding: 10px;
//           border-radius: 4px;
//           font-size: 14px;
//           max-height: 150px;
//           overflow-y: auto;
//           word-wrap: break-word;
//         }

//         .loading-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           height: 100vh;
//           font-size: 24px;
//         }

//         .preview-loading {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 40px 20px;
//           text-align: center;
//         }

//         .ai-generating-animation {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 20px;
//         }

//         .ai-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, #4285f4, #34a853);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           animation: pulse 2s infinite;
//         }

//         .ai-icon svg {
//           color: white;
//           width: 48px;
//           height: 48px;
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//           }
//           70% {
//             transform: scale(1.05);
//             box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//           }
//         }

//         .ai-text {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//         }

//         .ai-text p {
//           font-size: 18px;
//           font-weight: 500;
//           color: #333;
//         }

//         .ai-dots {
//           display: flex;
//           gap: 4px;
//         }

//         .ai-dots span {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background-color: #4285f4;
//           animation: bounce 1.4s infinite ease-in-out both;
//         }

//         .ai-dots span:nth-child(1) {
//           animation-delay: -0.32s;
//         }

//         .ai-dots span:nth-child(2) {
//           animation-delay: -0.16s;
//         }

//         @keyframes bounce {
//           0%,
//           80%,
//           100% {
//             transform: scale(0);
//           }
//           40% {
//             transform: scale(1);
//           }
//         }

//         @media (max-width: 768px) {
//           .main-content {
//             flex-direction: column;
//           }

//           .youtube-thumbnail-generator {
//             padding: 10px;
//           }

//           .header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 10px;
//           }

//           .ai-generating-animation {
//             padding: 20px;
//           }
//         }
//       `}</style>
//       </div>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;




// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;

//       const prompt = `
//         You are an expert front-end developer. Your task is to convert the provided UI/UX image into a single HTML file with embedded CSS.

//         The final output MUST be a single JSON object. The JSON object should contain two keys:
//         1.  "html": The complete and functional HTML code.
//         2.  "css": The complete CSS code.

//         Do NOT include any text before or after the JSON object. The response must be a valid JSON object.

//         Use the following framework and instructions:
//         - Framework: ${selectedFramework}
//         - Instructions: ${customPrompt || "Keep the design clean and as close to the image as possible."}

//         Make sure the code is production-ready, well-structured, and semantically correct.
//       `;

//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       // Extract JSON object from the raw text response
//       const jsonStart = rawText.indexOf('{');
//       const jsonEnd = rawText.lastIndexOf('}') + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   // New functions for copy and download
//   const handleCopy = (code, type) => {
//     navigator.clipboard.writeText(code).then(() => {
//         setSuccess(`${type} code copied to clipboard!`);
//         setTimeout(() => setSuccess(""), 3000); 
//     }).catch(err => {
//         setError("Failed to copy code.");
//         console.error('Copy failed', err);
//     });
//   };

//   const handleDownload = (content, fileName, mimeType) => {
//     const blob = new Blob([content], { type: mimeType });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     setSuccess(`${fileName} downloaded successfully!`);
//     setTimeout(() => setSuccess(""), 3000); 
//   };

//   const downloadHTML = () => {
//     handleDownload(generatedHTML, 'index.html', 'text/html');
//   };

//   const downloadCSS = () => {
//     handleDownload(generatedCSS, 'style.css', 'text/css');
//   };
//   // End of new functions

//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>
//           <img
//             src="https://i.ibb.co/L5r64d7/ui-ux-design-placeholder-image.png"
//             alt="UI/UX Placeholder"
//             style={{ maxWidth: "100%", height: "auto" }}
//             className="rounded"
//           />
//         </div>
//       );
//     }

//     const fullHTML = `
//       <!DOCTYPE html>
//       <html lang="en">
//       <head>
//         <title>UI Preview</title>
//         <style>${generatedCSS}</style>
//         ${
//           selectedFramework === "bootstrap"
//             ? '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">'
//             : selectedFramework === "tailwind"
//             ? '<script src="https://cdn.tailwindcss.com"></script>'
//             : ""
//         }
//       </head>
//       <body>
//         ${generatedHTML}
//       </body>
//       </html>
//     `;

//     return (
//       <iframe
//         title="UI Preview"
//         srcDoc={fullHTML}
//         style={{
//           width: "100%",
//           height: "500px",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//         }}
//       />
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to{" "}
//               <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h5>Live Preview</h5>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//           {generatedHTML && (
//             <div className="card shadow-sm p-4 mt-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="css-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#css-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="css-code"
//                     aria-selected="false"
//                   >
//                     CSS
//                   </button>
//                 </li>
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button className="btn btn-sm btn-outline-primary" onClick={() => handleCopy(generatedHTML, 'HTML')}>
//                         Copy HTML
//                     </button>
//                     <button className="btn btn-sm btn-outline-success" onClick={downloadHTML}>
//                         Download HTML
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//                 <div
//                   className="tab-pane fade"
//                   id="css-code"
//                   role="tabpanel"
//                   aria-labelledby="css-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button className="btn btn-sm btn-outline-primary" onClick={() => handleCopy(generatedCSS, 'CSS')}>
//                         Copy CSS
//                     </button>
//                     <button className="btn btn-sm btn-outline-success" onClick={downloadCSS}>
//                         Download CSS
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedCSS}</code>
//                   </pre>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//          <style jsx>{`
//         .youtube-thumbnail-generator {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 20px;
//         }

//         .credits-display {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .buy-credits-btn {
//           background-color: #4285f4;
//           color: white;
//           border: none;
//           padding: 5px 10px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .error-message {
//           color: #d32f2f;
//           background-color: #ffebee;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .success-message {
//           color: #388e3c;
//           background-color: #e8f5e9;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .main-content {
//           display: flex;
//           gap: 30px;
//           margin-bottom: 40px;
//         }

//         .form-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .form-group {
//           margin-bottom: 15px;
//         }

//         label {
//           display: block;
//           margin-bottom: 5px;
//           font-weight: bold;
//         }

//         input[type="text"],
//         select,
//         textarea {
//           width: 100%;
//           padding: 8px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           box-sizing: border-box;
//         }

//         .enhance-btn {
//           background-color: #fbbc05;
//           color: #333;
//           border: none;
//           padding: 8px 12px;
//           border-radius: 4px;
//           cursor: pointer;
//           margin-top: 8px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhance-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .form-actions {
//           display: flex;
//           gap: 10px;
//           margin-top: 20px;
//         }

//         .generate-btn,
//         .reset-btn {
//           padding: 10px 15px;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-weight: bold;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .generate-btn {
//           background-color: #ea4335;
//           color: white;
//           flex: 1;
//         }

//         .generate-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .reset-btn {
//           background-color: #f1f1f1;
//           color: #333;
//         }

//         .loading-spinner {
//           display: inline-block;
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: white;
//           animation: spin 1s ease-in-out infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         .preview-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .preview-container {
//           margin-bottom: 20px;
//         }

//         .generated-thumbnails {
//           display: flex;
//           flex-direction: column;
//           gap: 20px;
//         }

//         .thumbnail-item {
//           text-align: center;
//         }

//         .thumbnail-image {
//           max-width: 100%;
//           border-radius: 4px;
//           margin-bottom: 10px;
//         }

//         .download-btn {
//           background-color: #34a853;
//           color: white;
//           border: none;
//           padding: 8px 15px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .preview-placeholder {
//           text-align: center;
//           padding: 20px;
//         }

//         .thumbnail-frame {
//           width: 100%;
//           aspect-ratio: 16/9;
//           background-color: #333;
//           border-radius: 4px;
//           margin-top: 15px;
//           position: relative;
//           overflow: hidden;
//         }

//         .thumbnail-content {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           color: white;
//           padding: 20px;
//           box-sizing: border-box;
//         }

//         .thumbnail-title {
//           font-size: 24px;
//           font-weight: bold;
//           text-align: center;
//           color: #ff0000;
//           text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//         }

//         .preview-info {
//           margin-top: 20px;
//         }

//         .prompt-preview {
//           background-color: #e0e0e0;
//           padding: 10px;
//           border-radius: 4px;
//           font-size: 14px;
//           max-height: 150px;
//           overflow-y: auto;
//           word-wrap: break-word;
//         }

//         .loading-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           height: 100vh;
//           font-size: 24px;
//         }

//         .preview-loading {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 40px 20px;
//           text-align: center;
//         }

//         .ai-generating-animation {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 20px;
//         }

//         .ai-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, #4285f4, #34a853);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           animation: pulse 2s infinite;
//         }

//         .ai-icon svg {
//           color: white;
//           width: 48px;
//           height: 48px;
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//           }
//           70% {
//             transform: scale(1.05);
//             box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//           }
//         }

//         .ai-text {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//         }

//         .ai-text p {
//           font-size: 18px;
//           font-weight: 500;
//           color: #333;
//         }

//         .ai-dots {
//           display: flex;
//           gap: 4px;
//         }

//         .ai-dots span {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background-color: #4285f4;
//           animation: bounce 1.4s infinite ease-in-out both;
//         }

//         .ai-dots span:nth-child(1) {
//           animation-delay: -0.32s;
//         }

//         .ai-dots span:nth-child(2) {
//           animation-delay: -0.16s;
//         }

//         @keyframes bounce {
//           0%,
//           80%,
//           100% {
//             transform: scale(0);
//           }
//           40% {
//             transform: scale(1);
//           }
//         }

//         @media (max-width: 768px) {
//           .main-content {
//             flex-direction: column;
//           }

//           .youtube-thumbnail-generator {
//             padding: 10px;
//           }

//           .header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 10px;
//           }

//           .ai-generating-animation {
//             padding: 20px;
//           }
//         }
//       `}</style>
//       </div>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;


//       const prompt = `
// You are a highly skilled front-end developer and UI/UX expert. Your task is to convert the provided UI/UX image into a **single HTML file with embedded CSS** that is **production-ready, professional, clean, and fully responsive**.

// The final output MUST be a **single JSON object** containing two keys:
// 1. "html": The complete, functional, and semantic HTML code.
// 2. "css": The complete CSS code with responsiveness for all devices (desktop, tablet, mobile).

// Requirements:
// - Automatically detect the **background color** from the image and apply it.
// - Convert all visible elements including **logo, images, buttons, text, icons, forms, and layout sections** into HTML/CSS.
// - Ensure all **images are placed correctly** as per the design with proper alignment, margins, and paddings.
// - Maintain **precise spacing** between elements: correct margins, paddings, and element positioning.
// - Use **semantic HTML tags** and clean, structured CSS with proper classes and IDs.
// - Make the design **fully responsive**: elements must resize, reflow, and align properly across all screen sizes.
// - Ensure the code is **professional-quality** and ready for production.
// - Maintain **visual fidelity** to the original image, including fonts, colors, spacing, and proportions.
// - Framework: ${selectedFramework}
// - Additional instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

// **Important Notes**:
// - Do NOT include any text outside the JSON object.
// - Only output the JSON object with "html" and "css".
// - Ensure that code is high-quality, responsive, and all UI elements including images are correctly positioned with proper margins and paddings.
// `;



//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       const jsonStart = rawText.indexOf("{");
//       const jsonEnd = rawText.lastIndexOf("}") + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const handleCopy = (code, type) => {
//     navigator.clipboard
//       .writeText(code)
//       .then(() => {
//         setSuccess(`${type} code copied to clipboard!`);
//         setTimeout(() => setSuccess(""), 3000);
//       })
//       .catch((err) => {
//         setError("Failed to copy code.");
//         console.error("Copy failed", err);
//       });
//   };

//   const handleDownload = (content, fileName, mimeType) => {
//     const blob = new Blob([content], { type: mimeType });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     setSuccess(`${fileName} downloaded successfully!`);
//     setTimeout(() => setSuccess(""), 3000);
//   };

//   const downloadHTML = () => {
//     handleDownload(generatedHTML, "index.html", "text/html");
//   };

//   const downloadCSS = () => {
//     handleDownload(generatedCSS, "style.css", "text/css");
//   };

//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>

//         </div>
//       );
//     }

//     const fullHTML = `
//       <!DOCTYPE html>
//       <html lang="en">
//       <head>
//         <title>UI Preview</title>
//         <style>${generatedCSS}</style>
//         ${selectedFramework === "bootstrap"
//         ? '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">'
//         : selectedFramework === "tailwind"
//           ? '<script src="https://cdn.tailwindcss.com"></script>'
//           : ""
//       }
//       </head>
//       <body>
//         ${generatedHTML}
//       </body>
//       </html>
//     `;

//     return (
//       <iframe
//         title="UI Preview"
//         srcDoc={fullHTML}
//         style={{
//           width: "100%",
//           height: "500px",
//           border: "1px solid #ddd",
//           borderRadius: "8px",
//         }}
//       />
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h5>Live Preview</h5>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//           {generatedHTML && (
//             <div className="card shadow-sm p-4 mt-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="css-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#css-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="css-code"
//                     aria-selected="false"
//                   >
//                     CSS
//                   </button>
//                 </li>
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedHTML, "HTML")}
//                     >
//                       Copy HTML
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadHTML}
//                     >
//                       Download HTML
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//                 <div
//                   className="tab-pane fade"
//                   id="css-code"
//                   role="tabpanel"
//                   aria-labelledby="css-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedCSS, "CSS")}
//                     >
//                       Copy CSS
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadCSS}
//                     >
//                       Download CSS
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedCSS}</code>
//                   </pre>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         <style jsx>{`
//           .youtube-thumbnail-generator {
//             max-width: 1200px;
//             margin: 0 auto;
//             padding: 20px;
//             font-family: Arial, sans-serif;
//           }

//           .header {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             margin-bottom: 20px;
//           }

//           .credits-display {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//           }

//           .buy-credits-btn {
//             background-color: #4285f4;
//             color: white;
//             border: none;
//             padding: 5px 10px;
//             border-radius: 4px;
//             cursor: pointer;
//           }

//           .error-message {
//             color: #d32f2f;
//             background-color: #ffebee;
//             padding: 10px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//           }

//           .success-message {
//             color: #388e3c;
//             background-color: #e8f5e9;
//             padding: 10px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//           }

//           .main-content {
//             display: flex;
//             gap: 30px;
//             margin-bottom: 40px;
//           }

//           .form-section {
//             flex: 1;
//             background-color: #f9f9f9;
//             padding: 20px;
//             border-radius: 8px;
//           }

//           .form-group {
//             margin-bottom: 15px;
//           }

//           label {
//             display: block;
//             margin-bottom: 5px;
//             font-weight: bold;
//           }

//           input[type="text"],
//           select,
//           textarea {
//             width: 100%;
//             padding: 8px;
//             border: 1px solid #ddd;
//             border-radius: 4px;
//             box-sizing: border-box;
//           }

//           .enhance-btn {
//             background-color: #fbbc05;
//             color: #333;
//             border: none;
//             padding: 8px 12px;
//             border-radius: 4px;
//             cursor: pointer;
//             margin-top: 8px;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//           }

//           .enhance-btn:disabled {
//             background-color: #ccc;
//             cursor: not-allowed;
//           }

//           .form-actions {
//             display: flex;
//             gap: 10px;
//             margin-top: 20px;
//           }

//           .generate-btn,
//           .reset-btn {
//             padding: 10px 15px;
//             border: none;
//             border-radius: 4px;
//             cursor: pointer;
//             font-weight: bold;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }

//           .generate-btn {
//             background-color: #ea4335;
//             color: white;
//             flex: 1;
//           }

//           .generate-btn:disabled {
//             background-color: #ccc;
//             cursor: not-allowed;
//           }

//           .reset-btn {
//             background-color: #f1f1f1;
//             color: #333;
//           }

//           .loading-spinner {
//             display: inline-block;
//             width: 16px;
//             height: 16px;
//             border: 2px solid rgba(255, 255, 255, 0.3);
//             border-radius: 50%;
//             border-top-color: white;
//             animation: spin 1s ease-in-out infinite;
//           }

//           @keyframes spin {
//             to {
//               transform: rotate(360deg);
//             }
//           }

//           .preview-section {
//             flex: 1;
//             background-color: #f9f9f9;
//             padding: 20px;
//             border-radius: 8px;
//           }

//           .preview-container {
//             margin-bottom: 20px;
//           }

//           .generated-thumbnails {
//             display: flex;
//             flex-direction: column;
//             gap: 20px;
//           }

//           .thumbnail-item {
//             text-align: center;
//           }

//           .thumbnail-image {
//             max-width: 100%;
//             border-radius: 4px;
//             margin-bottom: 10px;
//           }

//           .download-btn {
//             background-color: #34a853;
//             color: white;
//             border: none;
//             padding: 8px 15px;
//             border-radius: 4px;
//             cursor: pointer;
//           }

//           .preview-placeholder {
//             text-align: center;
//             padding: 20px;
//           }

//           .thumbnail-frame {
//             width: 100%;
//             aspect-ratio: 16/9;
//             background-color: #333;
//             border-radius: 4px;
//             margin-top: 15px;
//             position: relative;
//             overflow: hidden;
//           }

//           .thumbnail-content {
//             position: absolute;
//             top: 0;
//             left: 0;
//             width: 100%;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             color: white;
//             padding: 20px;
//             box-sizing: border-box;
//           }

//           .thumbnail-title {
//             font-size: 24px;
//             font-weight: bold;
//             text-align: center;
//             color: #ff0000;
//             text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//           }

//           .preview-info {
//             margin-top: 20px;
//           }

//           .prompt-preview {
//             background-color: #e0e0e0;
//             padding: 10px;
//             border-radius: 4px;
//             font-size: 14px;
//             max-height: 150px;
//             overflow-y: auto;
//             word-wrap: break-word;
//           }

//           .loading-container {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             font-size: 24px;
//           }

//           .preview-loading {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//             padding: 40px 20px;
//             text-align: center;
//           }

//           .ai-generating-animation {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 20px;
//           }

//           .ai-icon {
//             width: 80px;
//             height: 80px;
//             background: linear-gradient(135deg, #4285f4, #34a853);
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             animation: pulse 2s infinite;
//           }

//           .ai-icon svg {
//             color: white;
//             width: 48px;
//             height: 48px;
//           }

//           @keyframes pulse {
//             0% {
//               transform: scale(1);
//               box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//             }
//             70% {
//               transform: scale(1.05);
//               box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//             }
//             100% {
//               transform: scale(1);
//               box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//             }
//           }

//           .ai-text {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 10px;
//           }

//           .ai-text p {
//             font-size: 18px;
//             font-weight: 500;
//             color: #333;
//           }

//           .ai-dots {
//             display: flex;
//             gap: 4px;
//           }

//           .ai-dots span {
//             width: 8px;
//             height: 8px;
//             border-radius: 50%;
//             background-color: #4285f4;
//             animation: bounce 1.4s infinite ease-in-out both;
//           }

//           .ai-dots span:nth-child(1) {
//             animation-delay: -0.32s;
//           }

//           .ai-dots span:nth-child(2) {
//             animation-delay: -0.16s;
//           }

//           @keyframes bounce {
//             0%,
//             80%,
//             100% {
//               transform: scale(0);
//             }
//             40% {
//               transform: scale(1);
//             }
//           }

//           @media (max-width: 768px) {
//             .main-content {
//               flex-direction: column;
//             }

//             .youtube-thumbnail-generator {
//               padding: 10px;
//             }

//             .header {
//               flex-direction: column;
//               align-items: flex-start;
//               gap: 10px;
//             }

//             .ai-generating-animation {
//               padding: 20px;
//             }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;




// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);
//   const [currentView, setCurrentView] = useState("desktop");

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;

//       const prompt = `
// You are a highly skilled front-end developer and UI/UX expert. Your task is to convert the provided UI/UX image into a **single HTML file with embedded CSS** that is **production-ready, professional, clean, and fully responsive**.

// The final output MUST be a **single JSON object** containing two keys:
// 1. "html": The complete, functional, and semantic HTML code.
// 2. "css": The complete CSS code with responsiveness for all devices (desktop, tablet, mobile).

// Requirements:
// - Automatically detect the **background color** from the image and apply it.
// - Convert all visible elements including **logo, images, buttons, text, icons, forms, and layout sections** into HTML/CSS.
// - Ensure all **images are placed correctly** as per the design with proper alignment, margins, and paddings.
// - Maintain **precise spacing** between elements: correct margins, paddings, and element positioning.
// - Use **semantic HTML tags** and clean, structured CSS with proper classes and IDs.
// - Make the design **fully responsive**: elements must resize, reflow, and align properly across all screen sizes.
// - Ensure the code is **professional-quality** and ready for production.
// - Maintain **visual fidelity** to the original image, including fonts, colors, spacing, and proportions.
// - Framework: ${selectedFramework}
// - Additional instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

// **Important Notes**:
// - Do NOT include any text outside the JSON object.
// - Only output the JSON object with "html" and "css".
// - Ensure that code is high-quality, responsive, and all UI elements including images are correctly positioned with proper margins and paddings.
// `;


//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       const jsonStart = rawText.indexOf("{");
//       const jsonEnd = rawText.lastIndexOf("}") + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const handleCopy = (code, type) => {
//     navigator.clipboard
//       .writeText(code)
//       .then(() => {
//         setSuccess(`${type} code copied to clipboard!`);
//         setTimeout(() => setSuccess(""), 3000);
//       })
//       .catch((err) => {
//         setError("Failed to copy code.");
//         console.error("Copy failed", err);
//       });
//   };

//   const handleDownload = (content, fileName, mimeType) => {
//     const blob = new Blob([content], { type: mimeType });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     setSuccess(`${fileName} downloaded successfully!`);
//     setTimeout(() => setSuccess(""), 3000);
//   };

//   const downloadHTML = () => {
//     handleDownload(generatedHTML, "index.html", "text/html");
//   };

//   const downloadCSS = () => {
//     handleDownload(generatedCSS, "style.css", "text/css");
//   };
//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>
//         </div>
//       );
//     }

//     const fullHTML = `
//     <!DOCTYPE html>
//     <html lang="en">
//     <head>
//       <title>UI Preview</title>
//       <style>${generatedCSS}</style>
//       ${selectedFramework === "bootstrap"
//         ? '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">'
//         : selectedFramework === "tailwind"
//           ? '<script src="https://cdn.tailwindcss.com"></script>'
//           : ""
//       }
//     </head>
//     <body>
//       ${generatedHTML}
//     </body>
//     </html>
//   `;

//     let iframeStyle = {
//       width: "100%",
//       height: "500px",
//       border: "1px solid #ddd",
//       borderRadius: "8px",
//       transition: "width 0.3s ease-in-out, height 0.3s ease-in-out, transform 0.3s ease-in-out",
//     };

//     let scale = 1;

//     if (currentView === 'tablet') {
//       iframeStyle.width = '768px';
//       iframeStyle.height = '1024px'; // Using a common tablet aspect ratio
//       scale = 0.65; // Adjust this value to fit your layout
//     } else if (currentView === 'mobile') {
//       iframeStyle.width = '375px';
//       iframeStyle.height = '667px'; // Common mobile aspect ratio
//       scale = 0.8; // Adjust this value to fit your layout
//     }

//     iframeStyle.transform = `scale(${scale})`;
//     iframeStyle.transformOrigin = 'top left';

//     return (
//       <div style={{ overflowX: 'auto' }}>
//         <iframe
//           title="UI Preview"
//           srcDoc={fullHTML}
//           style={iframeStyle}
//         />
//       </div>
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="col-lg-6">
//           <div className="card shadow-sm p-4">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h5 className="m-0">Live Preview</h5>
//               <div className="d-flex gap-2">
//                 <button
//                   className={`btn btn-sm ${currentView === 'desktop' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('desktop')}
//                 >
//                   <i className="fas fa-desktop"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'tablet' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('tablet')}
//                 >
//                   <i className="fas fa-tablet-alt"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('mobile')}
//                 >
//                   <i className="fas fa-mobile-alt"></i>
//                 </button>
//               </div>
//             </div>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//           {generatedHTML && (
//             <div className="card shadow-sm p-4 mt-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//                 {/* <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="css-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#css-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="css-code"
//                     aria-selected="false"
//                   >
//                     CSS
//                   </button>
//                 </li> */}
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedHTML, "HTML")}
//                     >
//                       Copy HTML
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadHTML}
//                     >
//                       Download HTML
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//                 <div
//                   className="tab-pane fade"
//                   id="css-code"
//                   role="tabpanel"
//                   aria-labelledby="css-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedCSS, "CSS")}
//                     >
//                       Copy CSS
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadCSS}
//                     >
//                       Download CSS
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedCSS}</code>
//                   </pre>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         <style jsx>{`
//           .youtube-thumbnail-generator {
//             max-width: 1200px;
//             margin: 0 auto;
//             padding: 20px;
//             font-family: Arial, sans-serif;
//           }

//           .header {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             margin-bottom: 20px;
//           }

//           .credits-display {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//           }

//           .buy-credits-btn {
//             background-color: #4285f4;
//             color: white;
//             border: none;
//             padding: 5px 10px;
//             border-radius: 4px;
//             cursor: pointer;
//           }

//           .error-message {
//             color: #d32f2f;
//             background-color: #ffebee;
//             padding: 10px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//           }

//           .success-message {
//             color: #388e3c;
//             background-color: #e8f5e9;
//             padding: 10px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//           }

//           .main-content {
//             display: flex;
//             gap: 30px;
//             margin-bottom: 40px;
//           }

//           .form-section {
//             flex: 1;
//             background-color: #f9f9f9;
//             padding: 20px;
//             border-radius: 8px;
//           }

//           .form-group {
//             margin-bottom: 15px;
//           }

//           label {
//             display: block;
//             margin-bottom: 5px;
//             font-weight: bold;
//           }

//           input[type="text"],
//           select,
//           textarea {
//             width: 100%;
//             padding: 8px;
//             border: 1px solid #ddd;
//             border-radius: 4px;
//             box-sizing: border-box;
//           }

//           .enhance-btn {
//             background-color: #fbbc05;
//             color: #333;
//             border: none;
//             padding: 8px 12px;
//             border-radius: 4px;
//             cursor: pointer;
//             margin-top: 8px;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//           }

//           .enhance-btn:disabled {
//             background-color: #ccc;
//             cursor: not-allowed;
//           }

//           .form-actions {
//             display: flex;
//             gap: 10px;
//             margin-top: 20px;
//           }

//           .generate-btn,
//           .reset-btn {
//             padding: 10px 15px;
//             border: none;
//             border-radius: 4px;
//             cursor: pointer;
//             font-weight: bold;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//           }

//           .generate-btn {
//             background-color: #ea4335;
//             color: white;
//             flex: 1;
//           }

//           .generate-btn:disabled {
//             background-color: #ccc;
//             cursor: not-allowed;
//           }

//           .reset-btn {
//             background-color: #f1f1f1;
//             color: #333;
//           }

//           .loading-spinner {
//             display: inline-block;
//             width: 16px;
//             height: 16px;
//             border: 2px solid rgba(255, 255, 255, 0.3);
//             border-radius: 50%;
//             border-top-color: white;
//             animation: spin 1s ease-in-out infinite;
//           }

//           @keyframes spin {
//             to {
//               transform: rotate(360deg);
//             }
//           }

//           .preview-section {
//             flex: 1;
//             background-color: #f9f9f9;
//             padding: 20px;
//             border-radius: 8px;
//           }

//           .preview-container {
//             margin-bottom: 20px;
//           }

//           .generated-thumbnails {
//             display: flex;
//             flex-direction: column;
//             gap: 20px;
//           }

//           .thumbnail-item {
//             text-align: center;
//           }

//           .thumbnail-image {
//             max-width: 100%;
//             border-radius: 4px;
//             margin-bottom: 10px;
//           }

//           .download-btn {
//             background-color: #34a853;
//             color: white;
//             border: none;
//             padding: 8px 15px;
//             border-radius: 4px;
//             cursor: pointer;
//           }

//           .preview-placeholder {
//             text-align: center;
//             padding: 20px;
//           }

//           .thumbnail-frame {
//             width: 100%;
//             aspect-ratio: 16/9;
//             background-color: #333;
//             border-radius: 4px;
//             margin-top: 15px;
//             position: relative;
//             overflow: hidden;
//           }

//           .thumbnail-content {
//             position: absolute;
//             top: 0;
//             left: 0;
//             width: 100%;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//             justify-content: center;
//             align-items: center;
//             color: white;
//             padding: 20px;
//             box-sizing: border-box;
//           }

//           .thumbnail-title {
//             font-size: 24px;
//             font-weight: bold;
//             text-align: center;
//             color: #ff0000;
//             text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//           }

//           .preview-info {
//             margin-top: 20px;
//           }

//           .prompt-preview {
//             background-color: #e0e0e0;
//             padding: 10px;
//             border-radius: 4px;
//             font-size: 14px;
//             max-height: 150px;
//             overflow-y: auto;
//             word-wrap: break-word;
//           }

//           .loading-container {
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             height: 100vh;
//             font-size: 24px;
//           }

//           .preview-loading {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             justify-content: center;
//             padding: 40px 20px;
//             text-align: center;
//           }

//           .ai-generating-animation {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 20px;
//           }

//           .ai-icon {
//             width: 80px;
//             height: 80px;
//             background: linear-gradient(135deg, #4285f4, #34a853);
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             animation: pulse 2s infinite;
//           }

//           .ai-icon svg {
//             color: white;
//             width: 48px;
//             height: 48px;
//           }

//           @keyframes pulse {
//             0% {
//               transform: scale(1);
//               box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//             }
//             70% {
//               transform: scale(1.05);
//               box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//             }
//             100% {
//               transform: scale(1);
//               box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//             }
//           }

//           .ai-text {
//             display: flex;
//             flex-direction: column;
//             align-items: center;
//             gap: 10px;
//           }

//           .ai-text p {
//             font-size: 18px;
//             font-weight: 500;
//             color: #333;
//           }

//           .ai-dots {
//             display: flex;
//             gap: 4px;
//           }

//           .ai-dots span {
//             width: 8px;
//             height: 8px;
//             border-radius: 50%;
//             background-color: #4285f4;
//             animation: bounce 1.4s infinite ease-in-out both;
//           }

//           .ai-dots span:nth-child(1) {
//             animation-delay: -0.32s;
//           }

//           .ai-dots span:nth-child(2) {
//             animation-delay: -0.16s;
//           }

//           @keyframes bounce {
//             0%,
//             80%,
//             100% {
//               transform: scale(0);
//             }
//             40% {
//               transform: scale(1);
//             }
//           }

//           @media (max-width: 768px) {
//             .main-content {
//               flex-direction: column;
//             }

//             .youtube-thumbnail-generator {
//               padding: 10px;
//             }

//             .header {
//               flex-direction: column;
//               align-items: flex-start;
//               gap: 10px;
//             }

//             .ai-generating-animation {
//               padding: 20px;
//             }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);
//   const [currentView, setCurrentView] = useState("desktop");

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;

//       const prompt = `
// You are a highly skilled front-end developer and UI/UX expert. Your task is to convert the provided UI/UX image into a **single HTML file with embedded CSS** that is **production-ready, professional, clean, and fully responsive**.

// The final output MUST be a **single JSON object** containing two keys:
// 1. "html": The complete, functional, and semantic HTML code.
// 2. "css": The complete CSS code with responsiveness for all devices (desktop, tablet, mobile).

// Requirements:
// - Automatically detect the **background color** from the image and apply it.
// - Convert all visible elements including **logo, images, buttons, text, icons, forms, and layout sections** into HTML/CSS.
// - Ensure all **images are placed correctly** as per the design with proper alignment, margins, and paddings.
// - Maintain **precise spacing** between elements: correct margins, paddings, and element positioning.
// - Use **semantic HTML tags** and clean, structured CSS with proper classes and IDs.
// - Make the design **fully responsive**: elements must resize, reflow, and align properly across all screen sizes.
// - Ensure the code is **professional-quality** and ready for production.
// - Maintain **visual fidelity** to the original image, including fonts, colors, spacing, and proportions.
// - Framework: ${selectedFramework}
// - Additional instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

// **Important Notes**:
// - Do NOT include any text outside the JSON object.
// - Only output the JSON object with "html" and "css".
// - Ensure that code is high-quality, responsive, and all UI elements including images are correctly positioned with proper margins and paddings.
// `;

//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       const jsonStart = rawText.indexOf("{");
//       const jsonEnd = rawText.lastIndexOf("}") + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const handleCopy = (code, type) => {
//     navigator.clipboard
//       .writeText(code)
//       .then(() => {
//         setSuccess(`${type} code copied to clipboard!`);
//         setTimeout(() => setSuccess(""), 3000);
//       })
//       .catch((err) => {
//         setError("Failed to copy code.");
//         console.error("Copy failed", err);
//       });
//   };

//   const handleDownload = (content, fileName, mimeType) => {
//     const blob = new Blob([content], { type: mimeType });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     setSuccess(`${fileName} downloaded successfully!`);
//     setTimeout(() => setSuccess(""), 3000);
//   };

//   const downloadHTML = () => {
//     handleDownload(generatedHTML, "index.html", "text/html");
//   };

//   const downloadCSS = () => {
//     handleDownload(generatedCSS, "style.css", "text/css");
//   };

//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>
//         </div>
//       );
//     }

//     const fullHTML = `
//       <!DOCTYPE html>
//       <html lang="en">
//       <head>
//         <title>UI Preview</title>
//         <style>${generatedCSS}</style>
//         ${selectedFramework === "bootstrap"
//         ? '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">'
//         : selectedFramework === "tailwind"
//           ? '<script src="https://cdn.tailwindcss.com"></script>'
//           : ""
//       }
//       </head>
//       <body>
//         ${generatedHTML}
//       </body>
//       </html>
//     `;

//     let iframeStyle = {
//       width: "100%",
//       height: "500px",
//       border: "1px solid #ddd",
//       borderRadius: "8px",
//       transition: "width 0.3s ease-in-out, height 0.3s ease-in-out, transform 0.3s ease-in-out",
//     };

//     let scale = 1;

//     if (currentView === 'tablet') {
//       iframeStyle.width = '768px';
//       iframeStyle.height = '1024px';
//       scale = 0.65;
//     } else if (currentView === 'mobile') {
//       iframeStyle.width = '375px';
//       iframeStyle.height = '667px';
//       scale = 0.8;
//     }

//     iframeStyle.transform = `scale(${scale})`;
//     iframeStyle.transformOrigin = 'top left';

//     return (
//       <div style={{ overflowX: 'auto' }}>
//         <iframe
//           title="UI Preview"
//           srcDoc={fullHTML}
//           style={iframeStyle}
//         />
//       </div>
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-12 mx-auto">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>



//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="row g-4 mt-4">
//         <div className="col-12">
//           <div className="card shadow-sm p-4">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h5 className="m-0">Live Preview</h5>
//               <div className="d-flex gap-2">
//                 <button
//                   className={`btn btn-sm ${currentView === 'desktop' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('desktop')}
//                 >
//                   <i className="fas fa-desktop"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'tablet' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('tablet')}
//                 >
//                   <i className="fas fa-tablet-alt"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('mobile')}
//                 >
//                   <i className="fas fa-mobile-alt"></i>
//                 </button>
//               </div>
//             </div>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//         </div>

//         {generatedHTML && (
//           <div className="col-12 mt-4">
//             <div className="card shadow-sm p-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedHTML, "HTML")}
//                     >
//                       Copy HTML
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadHTML}
//                     >
//                       Download HTML
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <style jsx>{`
//         .youtube-thumbnail-generator {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 20px;
//         }

//         .credits-display {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .buy-credits-btn {
//           background-color: #4285f4;
//           color: white;
//           border: none;
//           padding: 5px 10px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .error-message {
//           color: #d32f2f;
//           background-color: #ffebee;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .success-message {
//           color: #388e3c;
//           background-color: #e8f5e9;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .main-content {
//           display: flex;
//           gap: 30px;
//           margin-bottom: 40px;
//         }

//         .form-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .form-group {
//           margin-bottom: 15px;
//         }

//         label {
//           display: block;
//           margin-bottom: 5px;
//           font-weight: bold;
//         }

//         input[type="text"],
//         select,
//         textarea {
//           width: 100%;
//           padding: 8px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           box-sizing: border-box;
//         }

//         .enhance-btn {
//           background-color: #fbbc05;
//           color: #333;
//           border: none;
//           padding: 8px 12px;
//           border-radius: 4px;
//           cursor: pointer;
//           margin-top: 8px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhance-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .form-actions {
//           display: flex;
//           gap: 10px;
//           margin-top: 20px;
//         }

//         .generate-btn,
//         .reset-btn {
//           padding: 10px 15px;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-weight: bold;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .generate-btn {
//           background-color: #ea4335;
//           color: white;
//           flex: 1;
//         }

//         .generate-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .reset-btn {
//           background-color: #f1f1f1;
//           color: #333;
//         }

//         .loading-spinner {
//           display: inline-block;
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: white;
//           animation: spin 1s ease-in-out infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         .preview-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .preview-container {
//           margin-bottom: 20px;
//         }

//         .generated-thumbnails {
//           display: flex;
//           flex-direction: column;
//           gap: 20px;
//         }

//         .thumbnail-item {
//           text-align: center;
//         }

//         .thumbnail-image {
//           max-width: 100%;
//           border-radius: 4px;
//           margin-bottom: 10px;
//         }

//         .download-btn {
//           background-color: #34a853;
//           color: white;
//           border: none;
//           padding: 8px 15px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .preview-placeholder {
//           text-align: center;
//           padding: 20px;
//         }

//         .thumbnail-frame {
//           width: 100%;
//           aspect-ratio: 16/9;
//           background-color: #333;
//           border-radius: 4px;
//           margin-top: 15px;
//           position: relative;
//           overflow: hidden;
//         }

//         .thumbnail-content {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           color: white;
//           padding: 20px;
//           box-sizing: border-box;
//         }

//         .thumbnail-title {
//           font-size: 24px;
//           font-weight: bold;
//           text-align: center;
//           color: #ff0000;
//           text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//         }

//         .preview-info {
//           margin-top: 20px;
//         }

//         .prompt-preview {
//           background-color: #e0e0e0;
//           padding: 10px;
//           border-radius: 4px;
//           font-size: 14px;
//           max-height: 150px;
//           overflow-y: auto;
//           word-wrap: break-word;
//         }

//         .loading-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           height: 100vh;
//           font-size: 24px;
//         }

//         .preview-loading {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 40px 20px;
//           text-align: center;
//         }

//         .ai-generating-animation {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 20px;
//         }

//         .ai-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, #4285f4, #34a853);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           animation: pulse 2s infinite;
//         }

//         .ai-icon svg {
//           color: white;
//           width: 48px;
//           height: 48px;
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//           }
//           70% {
//             transform: scale(1.05);
//             box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//           }
//         }

//         .ai-text {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//         }

//         .ai-text p {
//           font-size: 18px;
//           font-weight: 500;
//           color: #333;
//         }

//         .ai-dots {
//           display: flex;
//           gap: 4px;
//         }

//         .ai-dots span {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background-color: #4285f4;
//           animation: bounce 1.4s infinite ease-in-out both;
//         }

//         .ai-dots span:nth-child(1) {
//           animation-delay: -0.32s;
//         }

//         .ai-dots span:nth-child(2) {
//           animation-delay: -0.16s;
//         }

//         @keyframes bounce {
//           0%,
//           80%,
//           100% {
//             transform: scale(0);
//           }
//           40% {
//             transform: scale(1);
//           }
//         }

//         @media (max-width: 768px) {
//           .main-content {
//             flex-direction: column;
//           }

//           .youtube-thumbnail-generator {
//             padding: 10px;
//           }

//           .header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 10px;
//           }

//           .ai-generating-animation {
//             padding: 20px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import auth from "../../firebase.init";
// import { useNavigate } from "react-router-dom";

// const ImageToHTMLCSSAI = () => {
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [credits, setCredits] = useState(0);

//   const navigate = useNavigate();

//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [uploadedImageBase64, setUploadedImageBase64] = useState("");
//   const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
//   const [selectedFramework, setSelectedFramework] = useState("tailwind");
//   const [customPrompt, setCustomPrompt] = useState("");
//   const [generatedHTML, setGeneratedHTML] = useState("");
//   const [generatedCSS, setGeneratedCSS] = useState("");
//   const [apiKeys, setApiKeys] = useState([]);
//   const [currentView, setCurrentView] = useState("desktop");

//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
//       if (response.data?.success && response.data.data) {
//         setApiKeys(response.data.data.map((keyObj) => keyObj.key));
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error(err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setLoading(false);
//         setLoadingKeys(false);
//         return;
//       }

//       try {
//         await fetchApiKeys();
//         const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           setCredits(userResponse.data[0].currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   const handleImageUpload = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       const reader = new FileReader();

//       reader.onload = () => {
//         const base64DataUrl = reader.result;
//         setUploadedImageUrl(base64DataUrl);
//         setUploadedImageBase64(base64DataUrl.split(",")[1]);
//         setUploadedImageMimeType(file.type);
//       };

//       reader.readAsDataURL(file);
//     }
//   };

//   const generateHTMLCSS = async () => {
//     if (!uploadedImageBase64) {
//       setError("Please upload a UI/UX image first.");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available");
//       return;
//     }
//     if (credits < 1) {
//       setError("Insufficient credits. Buy more to generate code.");
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setSuccess("");
//     setGeneratedHTML("");
//     setGeneratedCSS("");

//     try {
//       const deductResponse = await axios.post(
//         `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
//         { userEmail: user.email, amount: 1 }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - 1);

// const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;

//       const prompt = `
// You are a highly skilled front-end developer and UI/UX expert. Your task is to convert the provided UI/UX image into a **single HTML file with embedded CSS** that is **production-ready, professional, clean, and fully responsive**.

// The final output MUST be a **single JSON object** containing two keys:
// 1. "html": The complete, functional, and semantic HTML code.
// 2. "css": The complete CSS code with responsiveness for all devices (desktop, tablet, mobile).

// Requirements:
// - Automatically detect the **background color** from the image and apply it.
// - Convert all visible elements including **logo, images, buttons, text, icons, forms, and layout sections** into HTML/CSS.
// - Ensure all **images are placed correctly** as per the design with proper alignment, margins, and paddings.
// - Maintain **precise spacing** between elements: correct margins, paddings, and element positioning.
// - Use **semantic HTML tags** and clean, structured CSS with proper classes and IDs.
// - Make the design **fully responsive**: elements must resize, reflow, and align properly across all screen sizes.
// - Ensure the code is **professional-quality** and ready for production.
// - Maintain **visual fidelity** to the original image, including fonts, colors, spacing, and proportions.
// - Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
// - Additional instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

// **Important Notes**:
// - Do NOT include any text outside the JSON object.
// - Only output the JSON object with "html" and "css".
// - Ensure that code is high-quality, responsive, and all UI elements including images are correctly positioned with proper margins and paddings.
// - If the framework is 'tailwind' or 'bootstrap', use only the framework's classes and do **not** generate any custom CSS.
// - If the framework is 'custom', generate all necessary CSS in the "css" key.
// `;

//       const prompt = `
// You are a highly specialized and precise front-end developer. Your sole purpose is to convert the provided UI/UX image into a **single HTML file with embedded CSS**, replicating it with **100% accuracy**.

// The final output MUST be a **single JSON object** containing two keys: "html" and "css".

// **Mandatory Requirements for 100% Accuracy:**
// - **Pixel-Perfect Replication:** Recreate the layout, spacing, colors, fonts, and all visual elements exactly as they appear in the image.
// - **Background:** Automatically detect and apply the exact background color or style from the image.
// - **Element Conversion:** Convert every visible element (logo, images, text, buttons, icons, forms) into their correct HTML/CSS counterparts.
// - **Spacing:** Maintain precise margins, padding, and positioning to achieve the exact spacing between elements.
// - **Image Placement:** Ensure all images are placed and sized correctly.
// - **Code Quality:** Use clean, professional, and well-structured semantic HTML and CSS. The code must be production-ready.
// - **Responsiveness:** Make the design **fully responsive** and visually consistent across all device sizes (desktop, tablet, mobile).
// - **Strict Adherence:** Do not add any new elements, designs, or styles. Do not deviate from the source image. The generated code must be a perfect clone.

// **Framework-Specific Rule:**
// - **When the framework is 'bootstrap' or 'tailwind', use ONLY the framework's utility classes. Do NOT generate any custom CSS.** The "css" key in the JSON object must be an empty string ("").
// - When the framework is 'custom', generate all necessary styling in the "css" key.

// **Final Output Notes:**
// - Only output the JSON object. No extra text, no explanations, no markdown.
// - The output must be a single, valid JSON object ready to be parsed.
// `;

//       const prompt = `
// You are an extremely precise and skilled front-end developer. Your sole purpose is to convert the provided UI/UX image into code with **100% accuracy**.

// The final output **MUST** be a **single JSON object** with two keys: "html" and "css".

// **Critical Instructions for 100% Fidelity:**
// - **Replication:** Replicate the layout, spacing, colors, fonts, and all visual elements exactly as they appear in the image.
// - **Element Conversion:** Convert every visible element (logo, images, text, buttons, icons, forms) into their correct HTML/CSS counterparts.
// - **Code Quality:** Use clean, professional, and well-structured code.

// **Framework-Specific Rules:**
// - Framework: ${selectedFramework}
// - When the framework is **'bootstrap'** or **'tailwind'**, use **ONLY** the framework's utility classes. If the image contains a design element that cannot be created with these classes, **exclude that element** to ensure no custom CSS is generated. In this case, the "css" key must be an empty string ("").
// - When the framework is **'custom'**, include every detail from the design, even custom styles. In this case, the "css" key must contain all the necessary styling.

// **Final Output Notes:**
// - Only output the JSON object. Do not include any extra text, explanations, or markdown.
// - The output must be a single, valid JSON object ready for parsing.
// `;

//       const contents = [
//         {
//           role: "user",
//           parts: [
//             { text: prompt },
//             {
//               inlineData: {
//                 mimeType: uploadedImageMimeType,
//                 data: uploadedImageBase64,
//               },
//             },
//           ],
//         },
//       ];

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contents: contents }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();
//       const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

//       if (!rawText) {
//         throw new Error("No text was generated from the API response.");
//       }

//       const jsonStart = rawText.indexOf("{");
//       const jsonEnd = rawText.lastIndexOf("}") + 1;
//       const jsonString = rawText.substring(jsonStart, jsonEnd);

//       const generatedCode = JSON.parse(jsonString);

//       setGeneratedHTML(generatedCode.html);
//       setGeneratedCSS(generatedCode.css);
//       setSuccess("HTML and CSS generated successfully!");
//     } catch (err) {
//       console.error(err);
//       setError(`Error: ${err.message}`);
//       try {
//         await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: 1,
//         });
//         setCredits((prev) => prev + 1);
//       } catch (refundErr) {
//         console.error("Failed to refund credit:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const handleCopy = (code, type) => {
//     navigator.clipboard
//       .writeText(code)
//       .then(() => {
//         setSuccess(`${type} code copied to clipboard!`);
//         setTimeout(() => setSuccess(""), 3000);
//       })
//       .catch((err) => {
//         setError("Failed to copy code.");
//         console.error("Copy failed", err);
//       });
//   };

//   const handleDownload = (content, fileName, mimeType) => {
//     const blob = new Blob([content], { type: mimeType });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     URL.revokeObjectURL(url);
//     setSuccess(`${fileName} downloaded successfully!`);
//     setTimeout(() => setSuccess(""), 3000);
//   };

//   const downloadHTML = () => {
//     handleDownload(generatedHTML, "index.html", "text/html");
//   };

//   const downloadCSS = () => {
//     handleDownload(generatedCSS, "style.css", "text/css");
//   };

//   const renderPreview = () => {
//     if (!generatedHTML) {
//       return (
//         <div className="text-center text-muted py-5">
//           <p>Your generated UI will appear here.</p>
//         </div>
//       );
//     }

//     const getFullHTML = () => {
//       let styleTag = '';
//       if (selectedFramework === 'custom') {
//         styleTag = `<style>${generatedCSS}</style>`;
//       }

//       let frameworkLink = '';
//       if (selectedFramework === 'bootstrap') {
//         frameworkLink = '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">';
//       } else if (selectedFramework === 'tailwind') {
//         frameworkLink = '<script src="https://cdn.tailwindcss.com"></script>';
//       }

//       return `
//         <!DOCTYPE html>
//         <html lang="en">
//         <head>
//           <title>UI Preview</title>
//           ${styleTag}
//           ${frameworkLink}
//         </head>
//         <body>
//           ${generatedHTML}
//         </body>
//         </html>
//       `;
//     };

//     let iframeStyle = {
//       width: "100%",
//       height: "500px",
//       border: "1px solid #ddd",
//       borderRadius: "8px",
//       transition: "width 0.3s ease-in-out, height 0.3s ease-in-out, transform 0.3s ease-in-out",
//     };

//     let scale = 1;

//     if (currentView === 'tablet') {
//       iframeStyle.width = '768px';
//       iframeStyle.height = '1024px';
//       scale = 0.65;
//     } else if (currentView === 'mobile') {
//       iframeStyle.width = '375px';
//       iframeStyle.height = '667px';
//       scale = 0.8;
//     }

//     iframeStyle.transform = `scale(${scale})`;
//     iframeStyle.transformOrigin = 'top left';

//     return (
//       <div style={{ overflowX: 'auto' }}>
//         <iframe
//           title="UI Preview"
//           srcDoc={getFullHTML()}
//           style={iframeStyle}
//         />
//       </div>
//     );
//   };

//   if (loadingAuth || loading || loadingKeys)
//     return (
//       <div className="d-flex justify-content-center align-items-center vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "4rem", height: "4rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );

//   if (!user)
//     return (
//       <div className="container text-center py-5">
//         <h2>Please log in to use the Image to HTML CSS AI tool</h2>
//         <button
//           className="btn btn-primary mt-3"
//           onClick={() => (window.location.href = "/login")}
//         >
//           Go to Login
//         </button>
//       </div>
//     );

//   return (
//     <div className="container py-5">
//       <div className="row g-4">
//         <div className="col-lg-12 mx-auto">
//           <div className="card shadow-sm p-4">
//             <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
//               Image to <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
//             </h2>
//             <h4>Credits: {credits}</h4>
//             {credits < 1 && (
//               <button
//                 className="enhance-btn"
//                 onClick={() => navigate("/user/select-package")}
//               >
//                 Buy Now
//               </button>
//             )}
//             {error && <div className="alert alert-danger">{error}</div>}
//             {success && <div className="alert alert-success">{success}</div>}

//             <div className="mb-3 mt-3">
//               <label className="form-label">Upload UI/UX Image *</label>
//               <input
//                 type="file"
//                 className="form-control"
//                 accept="image/*"
//                 onChange={handleImageUpload}
//               />
//               {uploadedImageUrl && (
//                 <div className="mt-3 text-center">
//                   <img
//                     src={uploadedImageUrl}
//                     alt="Uploaded Preview"
//                     className="img-fluid rounded"
//                     style={{ maxHeight: "200px" }}
//                   />
//                 </div>
//               )}
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Select Framework</label>
//               <select
//                 className="form-select"
//                 value={selectedFramework}
//                 onChange={(e) => setSelectedFramework(e.target.value)}
//               >
//                 <option value="tailwind">Tailwind CSS</option>
//                 <option value="bootstrap">Bootstrap</option>
//                 <option value="custom">Custom CSS</option>
//               </select>
//             </div>

//             <div className="mb-3">
//               <label className="form-label">
//                 Specific Instructions (Optional)
//               </label>
//               <textarea
//                 className="form-control"
//                 value={customPrompt}
//                 onChange={(e) => setCustomPrompt(e.target.value)}
//                 placeholder="e.g., Make the buttons red, use a dark theme, etc."
//                 rows={2}
//               />
//             </div>

//             <div className="d-flex gap-2">
//               <button
//                 className="btn btn-danger flex-fill"
//                 onClick={generateHTMLCSS}
//                 disabled={generating || !uploadedImageBase64}
//               >
//                 {generating ? "Generating..." : "Generate HTML Code"}
//               </button>
//               <button
//                 className="btn btn-secondary flex-fill"
//                 onClick={() => {
//                   setUploadedImageUrl("");
//                   setUploadedImageBase64("");
//                   setCustomPrompt("");
//                   setGeneratedHTML("");
//                   setGeneratedCSS("");
//                   setError("");
//                   setSuccess("");
//                 }}
//                 disabled={generating}
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="row g-4 mt-4">
//         <div className="col-12">
//           <div className="card shadow-sm p-4">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h5 className="m-0">Live Preview</h5>
//               <div className="d-flex gap-2">
//                 <button
//                   className={`btn btn-sm ${currentView === 'desktop' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('desktop')}
//                 >
//                   <i className="fas fa-desktop"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'tablet' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('tablet')}
//                 >
//                   <i className="fas fa-tablet-alt"></i>
//                 </button>
//                 <button
//                   className={`btn btn-sm ${currentView === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`}
//                   onClick={() => setCurrentView('mobile')}
//                 >
//                   <i className="fas fa-mobile-alt"></i>
//                 </button>
//               </div>
//             </div>
//             {generating ? (
//               <div className="text-center py-5">
//                 <div className="ai-generating-animation">
//                   <div className="ai-icon mb-3">
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       viewBox="0 0 24 24"
//                       fill="currentColor"
//                       className="w-12 h-12"
//                     >
//                       <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
//                     </svg>
//                   </div>
//                   <p>AI is generating your code...</p>
//                   <div className="ai-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               renderPreview()
//             )}
//           </div>
//         </div>

//         {generatedHTML && (
//           <div className="col-12 mt-4">
//             <div className="card shadow-sm p-4">
//               <h5>Generated Code</h5>
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="html-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#html-code"
//                     type="button"
//                     role="tab"
//                     aria-controls="html-code"
//                     aria-selected="true"
//                   >
//                     HTML
//                   </button>
//                 </li>
//                 {selectedFramework === 'custom' && (
//                   <li className="nav-item" role="presentation">
//                     <button
//                       className="nav-link"
//                       id="css-tab"
//                       data-bs-toggle="tab"
//                       data-bs-target="#css-code"
//                       type="button"
//                       role="tab"
//                       aria-controls="css-code"
//                       aria-selected="false"
//                     >
//                       CSS
//                     </button>
//                   </li>
//                 )}
//               </ul>
//               <div className="tab-content" id="myTabContent">
//                 <div
//                   className="tab-pane fade show active"
//                   id="html-code"
//                   role="tabpanel"
//                   aria-labelledby="html-tab"
//                 >
//                   <div className="d-flex justify-content-end gap-2 mt-3">
//                     <button
//                       className="btn btn-sm btn-outline-primary"
//                       onClick={() => handleCopy(generatedHTML, "HTML")}
//                     >
//                       Copy HTML
//                     </button>
//                     <button
//                       className="btn btn-sm btn-outline-success"
//                       onClick={downloadHTML}
//                     >
//                       Download HTML
//                     </button>
//                   </div>
//                   <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                     <code>{generatedHTML}</code>
//                   </pre>
//                 </div>
//                 {selectedFramework === 'custom' && (
//                   <div
//                     className="tab-pane fade"
//                     id="css-code"
//                     role="tabpanel"
//                     aria-labelledby="css-tab"
//                   >
//                     <div className="d-flex justify-content-end gap-2 mt-3">
//                       <button
//                         className="btn btn-sm btn-outline-primary"
//                         onClick={() => handleCopy(generatedCSS, "CSS")}
//                       >
//                         Copy CSS
//                       </button>
//                       <button
//                         className="btn btn-sm btn-outline-success"
//                         onClick={downloadCSS}
//                       >
//                         Download CSS
//                       </button>
//                     </div>
//                     <pre className="p-3 bg-light rounded mt-3 overflow-auto">
//                       <code>{generatedCSS}</code>
//                     </pre>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <style jsx>{`
//         .youtube-thumbnail-generator {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 20px;
//         }

//         .credits-display {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//         }

//         .buy-credits-btn {
//           background-color: #4285f4;
//           color: white;
//           border: none;
//           padding: 5px 10px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .error-message {
//           color: #d32f2f;
//           background-color: #ffebee;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .success-message {
//           color: #388e3c;
//           background-color: #e8f5e9;
//           padding: 10px;
//           border-radius: 4px;
//           margin-bottom: 15px;
//         }

//         .main-content {
//           display: flex;
//           gap: 30px;
//           margin-bottom: 40px;
//         }

//         .form-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .form-group {
//           margin-bottom: 15px;
//         }

//         label {
//           display: block;
//           margin-bottom: 5px;
//           font-weight: bold;
//         }

//         input[type="text"],
//         select,
//         textarea {
//           width: 100%;
//           padding: 8px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           box-sizing: border-box;
//         }

//         .enhance-btn {
//           background-color: #fbbc05;
//           color: #333;
//           border: none;
//           padding: 8px 12px;
//           border-radius: 4px;
//           cursor: pointer;
//           margin-top: 8px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .enhance-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .form-actions {
//           display: flex;
//           gap: 10px;
//           margin-top: 20px;
//         }

//         .generate-btn,
//         .reset-btn {
//           padding: 10px 15px;
//           border: none;
//           border-radius: 4px;
//           cursor: pointer;
//           font-weight: bold;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .generate-btn {
//           background-color: #ea4335;
//           color: white;
//           flex: 1;
//         }

//         .generate-btn:disabled {
//           background-color: #ccc;
//           cursor: not-allowed;
//         }

//         .reset-btn {
//           background-color: #f1f1f1;
//           color: #333;
//         }

//         .loading-spinner {
//           display: inline-block;
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: white;
//           animation: spin 1s ease-in-out infinite;
//         }

//         @keyframes spin {
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         .preview-section {
//           flex: 1;
//           background-color: #f9f9f9;
//           padding: 20px;
//           border-radius: 8px;
//         }

//         .preview-container {
//           margin-bottom: 20px;
//         }

//         .generated-thumbnails {
//           display: flex;
//           flex-direction: column;
//           gap: 20px;
//         }

//         .thumbnail-item {
//           text-align: center;
//         }

//         .thumbnail-image {
//           max-width: 100%;
//           border-radius: 4px;
//           margin-bottom: 10px;
//         }

//         .download-btn {
//           background-color: #34a853;
//           color: white;
//           border: none;
//           padding: 8px 15px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         .preview-placeholder {
//           text-align: center;
//           padding: 20px;
//         }

//         .thumbnail-frame {
//           width: 100%;
//           aspect-ratio: 16/9;
//           background-color: #333;
//           border-radius: 4px;
//           margin-top: 15px;
//           position: relative;
//           overflow: hidden;
//         }

//         .thumbnail-content {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           display: flex;
//           flex-direction: column;
//           justify-content: center;
//           align-items: center;
//           color: white;
//           padding: 20px;
//           box-sizing: border-box;
//         }

//         .thumbnail-title {
//           font-size: 24px;
//           font-weight: bold;
//           text-align: center;
//           color: #ff0000;
//           text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
//         }

//         .preview-info {
//           margin-top: 20px;
//         }

//         .prompt-preview {
//           background-color: #e0e0e0;
//           padding: 10px;
//           border-radius: 4px;
//           font-size: 14px;
//           max-height: 150px;
//           overflow-y: auto;
//           word-wrap: break-word;
//         }

//         .loading-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           height: 100vh;
//           font-size: 24px;
//         }

//         .preview-loading {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 40px 20px;
//           text-align: center;
//         }

//         .ai-generating-animation {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 20px;
//         }

//         .ai-icon {
//           width: 80px;
//           height: 80px;
//           background: linear-gradient(135deg, #4285f4, #34a853);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           animation: pulse 2s infinite;
//         }

//         .ai-icon svg {
//           color: white;
//           width: 48px;
//           height: 48px;
//         }

//         @keyframes pulse {
//           0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
//           }
//           70% {
//             transform: scale(1.05);
//             box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
//           }
//           100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
//           }
//         }

//         .ai-text {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           gap: 10px;
//         }

//         .ai-text p {
//           font-size: 18px;
//           font-weight: 500;
//           color: #333;
//         }

//         .ai-dots {
//           display: flex;
//           gap: 4px;
//         }

//         .ai-dots span {
//           width: 8px;
//           height: 8px;
//           border-radius: 50%;
//           background-color: #4285f4;
//           animation: bounce 1.4s infinite ease-in-out both;
//         }

//         .ai-dots span:nth-child(1) {
//           animation-delay: -0.32s;
//         }

//         .ai-dots span:nth-child(2) {
//           animation-delay: -0.16s;
//         }

//         @keyframes bounce {
//           0%,
//           80%,
//           100% {
//             transform: scale(0);
//           }
//           40% {
//             transform: scale(1);
//           }
//         }

//         @media (max-width: 768px) {
//           .main-content {
//             flex-direction: column;
//           }

//           .youtube-thumbnail-generator {
//             padding: 10px;
//           }

//           .header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 10px;
//           }

//           .ai-generating-animation {
//             padding: 20px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ImageToHTMLCSSAI;



import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import { useNavigate } from "react-router-dom";

const ImageToHTMLCSSAI = () => {
  // Authentication and state management
  const [user, loadingAuth] = useAuthState(auth);
  const [loading, setLoading] = useState(true);
  const [loadingKeys, setLoadingKeys] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [credits, setCredits] = useState(0);
  const navigate = useNavigate();

  // Component-specific state
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [uploadedImageBase64, setUploadedImageBase64] = useState("");
  const [uploadedImageMimeType, setUploadedImageMimeType] = useState("");
  const [selectedFramework, setSelectedFramework] = useState("tailwind");
  const [customPrompt, setCustomPrompt] = useState("");
  const [generatedHTML, setGeneratedHTML] = useState("");
  const [generatedCSS, setGeneratedCSS] = useState("");
  const [apiKeys, setApiKeys] = useState([]);
  const [currentView, setCurrentView] = useState("desktop");

  // Fetch API keys and user data
  useEffect(() => {
    const fetchData = async () => {
      if (loadingAuth) return;
      if (!user) {
        setLoading(false);
        setLoadingKeys(false);
        return;
      }

      try {
        await fetchApiKeys();
        const userResponse = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/users`, {
          params: { userEmail: user.email },
        });
        if (userResponse.data && userResponse.data.length > 0) {
          setCredits(userResponse.data[0].currentBalance);
        } else {
          setError("User data not found");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user, loadingAuth]);

  const fetchApiKeys = async () => {
    try {
      const response = await axios.get(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/gemini-keys`);
      if (response.data?.success && response.data.data) {
        setApiKeys(response.data.data.map((keyObj) => keyObj.key));
      } else {
        setError("Failed to load API keys");
      }
    } catch (err) {
      console.error(err);
      setError("Error loading API keys");
    } finally {
      setLoadingKeys(false);
    }
  };

  const getRandomApiKey = () => {
    if (apiKeys.length === 0) throw new Error("No API keys available");
    return apiKeys[Math.floor(Math.random() * apiKeys.length)];
  };

  const handleImageUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        const base64DataUrl = reader.result;
        setUploadedImageUrl(base64DataUrl);
        setUploadedImageBase64(base64DataUrl.split(",")[1]);
        setUploadedImageMimeType(file.type);
      };

      reader.readAsDataURL(file);
    }
  };

  const generateHTMLCSS = async () => {
    if (!uploadedImageBase64) {
      setError("Please upload a UI/UX image first.");
      return;
    }
    if (apiKeys.length === 0) {
      setError("No API keys available");
      return;
    }
    if (credits < 1) {
      setError("Insufficient credits. Buy more to generate code.");
      return;
    }

    setGenerating(true);
    setError("");
    setSuccess("");
    setGeneratedHTML("");
    setGeneratedCSS("");

    try {
      const deductResponse = await axios.post(
        `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/deduct-credit`,
        { userEmail: user.email, amount: 1 }
      );
      if (!deductResponse.data.success) {
        throw new Error("Failed to deduct credits");
      }
      setCredits((prev) => prev - 1);

      const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${getRandomApiKey()}`;

      // const prompt = `
      //   You are an extremely precise and skilled front-end developer. Your sole purpose is to convert the provided UI/UX image into code with **100% accuracy**.

      //   The final output **MUST** be a **single JSON object** with two keys: "html" and "css".

      //   **Critical Instructions for 100% Fidelity:**
      //   - **Replication:** Replicate the layout, spacing, colors, fonts, and all visual elements exactly as they appear in the image.
      //   - **Element Conversion:** Convert every visible element (logo, images, text, buttons, icons, forms) into their correct HTML/CSS counterparts.
      //   - **Code Quality:** Use clean, professional, and well-structured code.

      //   **Framework-Specific Rules:**
      //   - Framework: ${selectedFramework}
      //   - When the framework is **'bootstrap'** or **'tailwind'**, use **ONLY** the framework's utility classes. If the image contains a design element that cannot be created with these classes, **exclude that element** to ensure no custom CSS is generated. In this case, the "css" key must be an empty string ("").
      //   - When the framework is **'custom'**, include every detail from the design, even custom styles. In this case, the "css" key must contain all the necessary styling.

      //   **Final Output Notes:**
      //   - Only output the JSON object. Do not include any extra text, explanations, or markdown.
      //   - The output must be a single, valid JSON object ready for parsing.
      // `;


      //       const prompt = `
      // You are an extremely precise and highly skilled front-end developer and UI/UX expert. Your sole purpose is to convert the provided UI/UX image into production-ready front-end code with the highest possible visual fidelity to the image.

      // INPUT VARIABLES AVAILABLE:
      // - ${selectedFramework}     // either "bootstrap", "tailwind", or "custom"
      // - ${customPrompt}          // optional extra instructions provided by the user
      // - The UI/UX image file (use this image as the single source of truth)

      // FINAL OUTPUT FORMAT (MANDATORY):
      // Return ONLY a single JSON object (no extra text, no Markdown, no comments) with exactly two keys:
      // 1. "html" — a complete, semantic, single HTML file (doctype, head, body). The HTML must include any necessary link/preload tags (fonts, icons) and must place images using relative src placeholders (e.g., "assets/img/…") exactly where they appear in the design.
      // 2. "css" — the full CSS required for the design (or an empty string "").

      // CORE REQUIREMENTS FOR 100% FIDELITY:
      // - Replicate layout, spacing, fonts, colors, alignment, and proportions as shown in the image.
      // - Convert every visible element (logo, images, headings, body text, buttons, icons, inputs, forms, badges, navs, cards, background ornaments) into HTML/CSS elements.
      // - Automatically detect and apply the **background color** from the image to the root or body element.
      // - Preserve precise spacing: use correct margins, paddings, gaps, and positioning so elements match the image layout.
      // - Use semantic HTML5 tags where appropriate (header, nav, main, section, article, footer, form, figure, figcaption).
      // - Ensure images are placed and sized correctly according to the design; use appropriate object-fit/object-position values for photos and illustrations.
      // - Include accessibility best-practices: meaningful alt attributes, accessible button elements, labels for form fields, and logical heading hierarchy.
      // - Make the design fully responsive: provide styles / classes to support desktop, tablet, and mobile breakpoints with graceful reflow.

      // FRAMEWORK-SPECIFIC RULES:
      // - If ${selectedFramework} is "tailwind" or "bootstrap":
      //   - Use ONLY that framework's utility/classes in the HTML. Do NOT generate any custom CSS rules.
      //   - If you cannot reproduce a specific visual element using only the framework utilities, omit that element from the output to avoid custom CSS.
      //   - In this omission case, the JSON "css" value MUST be the empty string "".
      //   - The "html" must rely exclusively on framework classes and valid markup.
      // - If ${selectedFramework} is "custom":
      //   - Produce complete custom CSS in the "css" key that reproduces every visible detail from the image (colors, spacing, typography, shadows, gradients, borders, responsive breakpoints).
      //   - Use well-structured, maintainable CSS: logical class names, BEM-like structure where helpful, and media queries for responsive behavior.
      //   - If custom fonts appear to be used in the image, include a best-match Google Fonts import or a reasonable fallback stack and reference it in CSS.

      // ADDITIONAL PRACTICAL RULES:
      // - Do NOT output any explanation, notes, or extra text — only the single JSON object.
      // - Keep HTML minimal but complete and functional; do not include unused libraries or scripts.
      // - Use relative asset paths for images (e.g., "assets/img/hero.jpg") so the output is portable.
      // - If icons are visible and you can reproduce them with simple SVG inlined in the HTML, inline them. If they are complex and not reproducible with plain HTML/CSS, use placeholder inline SVGs that match shape and size.
      // - Attempt to match font sizes, line-heights, letter-spacing, and color hex codes exactly. If an exact font cannot be identified, choose a close web-safe/Google Font and include the import in the HTML head (only when framework is "custom" or when an external font is necessary).
      // - Ensure forms, buttons, and interactive elements use realistic HTML (e.g., <button>, <input>, <label>) and include focus styles.

      // ADDITIONAL INSTRUCTIONS:
      // - Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
      // - Extra user instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

      // EXAMPLE OF REQUIRED OUTPUT (NOT LITERAL — DO NOT COPY THIS example into your response):
      // {
      //   "html": "<!doctype html>... full single-file html ...",
      //   "css": "/* full css for custom framework OR empty string if using bootstrap/tailwind and omitted elements */"
      // }

      // Again: OUTPUT ONLY the single JSON object with keys "html" and "css". No text before or after. No markdown. No commentary.
      // `;


      //       const prompt = `
      // You are an extremely precise and highly skilled front-end developer and UI/UX expert. Your sole purpose is to convert the provided UI/UX image into production-ready front-end code with the highest possible visual fidelity to the image.

      // INPUT VARIABLES AVAILABLE:
      // - ${selectedFramework}     // either "bootstrap", "tailwind", or "custom"
      // - ${customPrompt}          // optional extra instructions provided by the user
      // - The UI/UX image file (use this image as the single source of truth)

      // FINAL OUTPUT FORMAT (MANDATORY):
      // Return ONLY a single JSON object (no extra text, no Markdown, no comments) with exactly two keys:
      // 1. "html" — a complete, semantic, single HTML file (doctype, head, body). The HTML must include any necessary link/preload tags (fonts, icons) and must place images using placeholder URLs exactly where they appear in the design.
      // 2. "css" — the full CSS required for the design (or an empty string "").

      // CORE REQUIREMENTS FOR 100% FIDELITY:
      // - Replicate layout, spacing, fonts, colors, alignment, and proportions as shown in the image.
      // - Convert every visible element (logo, images, headings, body text, buttons, icons, inputs, forms, badges, navs, cards, background ornaments) into HTML/CSS elements.
      // - Automatically detect and apply the **background color** from the image to the root or body element.
      // - Preserve precise spacing: use correct margins, paddings, gaps, and positioning so elements match the image layout.
      // - Use semantic HTML5 tags where appropriate (header, nav, main, section, article, footer, form, figure, figcaption).
      // - Ensure images are placed and sized correctly according to the design; use appropriate object-fit/object-position values for photos and illustrations.
      // - Include accessibility best-practices: meaningful alt attributes, accessible button elements, labels for form fields, and logical heading hierarchy.
      // - Make the design fully responsive: provide styles / classes to support desktop, tablet, and mobile breakpoints with graceful reflow.

      // IMAGE PLACEHOLDER RULE (MANDATORY — DO NOT OMIT):
      // - Do NOT include or embed any original / source photos or assets from the uploaded image file in the output.
      // - For every image location visible in the design (photos, illustrations, logos, thumbnails, background images), use the placeholder image URL **"https://placehold.co/600x400"**.
      // - Place the placeholder in the same position, size, aspect ratio, and object-fit as the original image in the design. Use object-fit: cover or object-fit: contain as appropriate to match the design.
      // - For logos and small decorative images, also use "https://placehold.co/600x400" but set alt attributes like "logo placeholder".
      // - For complex icons/illustrations that can be reproduced with simple SVG, inline a minimal SVG placeholder that matches shape/size. For icons that cannot be reproduced, use a simple inline SVG box placeholder (no external images).
      // - All image tags must include meaningful alt text describing the placeholder role (e.g., "hero image placeholder", "product image placeholder").
      // - DO NOT attempt to show the original image, blur it, or export it — always use the placeholder URL above.

      // FRAMEWORK-SPECIFIC RULES:
      // - If ${selectedFramework} is "tailwind" or "bootstrap":
      //   - Use ONLY that framework's utility/classes in the HTML. Do NOT generate any custom CSS rules.
      //   - If you cannot reproduce a specific visual element using only the framework utilities, omit that element from the output to avoid custom CSS.
      //   - In this omission case, the JSON "css" value MUST be the empty string "".
      //   - The "html" must rely exclusively on framework classes and valid markup.
      // - If ${selectedFramework} is "custom":
      //   - Produce complete custom CSS in the "css" key that reproduces every visible detail from the image (colors, spacing, typography, shadows, gradients, borders, responsive breakpoints).
      //   - Use well-structured, maintainable CSS: logical class names, BEM-like structure where helpful, and media queries for responsive behavior.
      //   - If custom fonts appear to be used in the image, include a best-match Google Fonts import or a reasonable fallback stack and reference it in CSS.

      // ADDITIONAL PRACTICAL RULES:
      // - Do NOT output any explanation, notes, or extra text — only the single JSON object.
      // - Keep HTML minimal but complete and functional; do not include unused libraries or scripts.
      // - Use placeholder URLs for images (e.g., "https://placehold.co/600x400") so the output is portable.
      // - If icons are visible and you can reproduce them with simple SVG inlined in the HTML, inline them. If they are complex and not reproducible with plain HTML/CSS, use placeholder inline SVGs that match shape and size.
      // - Attempt to match font sizes, line-heights, letter-spacing, and color hex codes exactly. If an exact font cannot be identified, choose a close web-safe/Google Font and include the import in the HTML head (only when framework is "custom" or when an external font is necessary).
      // - Ensure forms, buttons, and interactive elements use realistic HTML (e.g., <button>, <input>, <label>) and include focus styles.

      // ADDITIONAL INSTRUCTIONS:
      // - Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
      // - Extra user instructions: ${customPrompt || "Keep the design clean, visually balanced, and closely match the image layout."}

      // NOTE: use "https://placehold.co/600x400" as the single placeholder image for every image location in the output. Icons may be inline SVG placeholders. Amar instruction: image-er jaygai shob somoy placeholder use koro (do not output real images).
      // `;


      //       const prompt = `
      // You are a highly skilled front-end developer and UI/UX expert. Convert the provided UI/UX image into production-ready front-end code with exact visual fidelity.

      // INPUT:
      // - ${selectedFramework} // "bootstrap", "tailwind", or "custom"
      // - ${customPrompt} // optional extra instructions
      // - The UI/UX image file (single source of truth)

      // OUTPUT (JSON ONLY):
      // {
      //   "html": "Complete HTML file (doctype, head, body) with semantic tags, responsive layout, and placeholder images.",
      //   "css": "Full CSS if custom; empty string if using framework utilities only."
      // }

      // REQUIREMENTS:
      // 1. Layout, spacing, fonts, colors, alignment, proportions must match image.
      // 2. Convert all visible elements: logos, images, headings, text, buttons, icons, inputs, forms, navs, cards, backgrounds.
      // 3. Background color detected from image applied to root/body.
      // 4. Use semantic HTML5 tags: header, nav, main, section, article, footer, form, figure, figcaption.
      // 5. Place images with placeholder URL: "https://placehold.co/600x400" and proper alt text (e.g., "hero image placeholder").
      // 6. Inline simple SVG for icons; use SVG box placeholder if complex.
      // 7. Preserve spacing (margins, paddings, gaps, positions) exactly.
      // 8. Fully responsive with desktop, tablet, mobile styles.
      // 9. Accessibility: alt attributes, labels, proper heading hierarchy, accessible buttons/inputs.
      // 10. For framework "tailwind" or "bootstrap": use only framework classes; no custom CSS; JSON "css": "".
      // 11. For "custom": produce full custom CSS including fonts, colors, spacing, responsive media queries.
      // 12. Do not embed real images or assets from the image.
      // 13. Match font sizes, line-height, letter-spacing; use close web-safe/Google fonts if exact font unknown.
      // 14. Forms and interactive elements use realistic HTML and include focus styles.

      // ADDITIONAL:
      // - Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
      // - Extra instructions: ${customPrompt || "Keep the design clean, visually balanced, and match the image layout."}
      // - Always use placeholder images; do not output real images.
      // `;


      const prompt = `
You are a highly skilled front-end developer and UI/UX expert. Convert the provided UI/UX image into production-ready front-end code with **exact visual fidelity**.

INPUT:
- ${selectedFramework} // "bootstrap", "tailwind", or "custom"
- ${customPrompt} // optional extra instructions
- The UI/UX image file (single source of truth)

OUTPUT (JSON ONLY):
{
  "html": "Complete HTML file (doctype, head, body) with semantic tags, responsive layout, and placeholder images.",
  "css": "Full CSS if custom; empty string if using framework utilities only."
}

REQUIREMENTS:
1. Layout, spacing, fonts, colors, alignment, proportions must match the image **pixel-for-pixel accuracy**.
2. Convert all visible elements: logos, images, headings, text, buttons, icons, inputs, forms, navs, cards, backgrounds.
3. **Detect background colors and background images from the design**:
   - Apply solid background colors to root/body or sections as in the image.
   - For background images, use placeholder images: "https://placehold.co/1920x1080" with proper alt text (e.g., "background image placeholder").
4. Use semantic HTML5 tags: If header, nav, main, section, article, footer, form, figure, figcaption.
5. Place all other images with placeholder URL: "https://placehold.co/600x400" and proper alt text.
6. Inline simple SVG for icons; use SVG placeholder if complex.
7. Preserve exact spacing (margins, paddings, gaps, positions) and match proportions precisely.
8. Fully responsive with smooth adaptation for **320px (mobile), 768px (tablet), and 1200px+ (desktop)**.
9. Accessibility: alt attributes, labels, proper heading hierarchy, accessible buttons/inputs.
10. For framework "tailwind" or "bootstrap": use only framework classes; no custom CSS; JSON "css": "".
11. For "custom": produce full custom CSS including fonts, colors, spacing, responsive media queries.
12. Do not embed real images or assets from the image.
13. Match font sizes, line-height, and letter-spacing. Use Google Fonts if detected; fallback to Arial, Helvetica, sans-serif if unknown.
14. Forms and interactive elements must include realistic HTML with **hover, active, and focus styles visually matching the design**.
15. Ensure all code validates with **W3C HTML and CSS standards** and avoid unused/extra code.

ADDITIONAL:
- Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
- Extra instructions: ${customPrompt || "Keep the design clean, visually balanced, and match the image layout exactly."}
- Always use placeholder images; do not output real images.
- Background colors and background images must match the UI/UX design exactly.
`;


      // const prompt = `
      // You are a highly skilled front-end developer and UI/UX expert. Convert the provided UI/UX image into production-ready front-end code with **exact visual fidelity**.

      // INPUT:
      // - ${selectedFramework} // "bootstrap", "tailwind", or "custom"
      // - ${customPrompt} // optional extra instructions
      // - The UI/UX image file (single source of truth)

      // OUTPUT (JSON ONLY):
      // {
      //   "html": "Complete HTML file (doctype, head, body) with semantic tags, responsive layout, and placeholder images.",
      //   "css": "Full CSS if custom; empty string if using framework utilities only."
      // }

      // REQUIREMENTS:
      // 1. Layout, spacing, fonts, colors, alignment, proportions must match the image exactly.
      // 2. Convert all visible elements: logos, images, headings, text, buttons, icons, inputs, forms, navs, cards, backgrounds.
      // 3. **Detect background colors and background images from the design**:
      //    - Apply solid background colors to root/body or sections as in the image.
      //    - For background images, use placeholder images: "https://placehold.co/1920x1080" with proper alt text (e.g., "background image placeholder").
      // 4. Use semantic HTML5 tags: header, nav, main, section, article, footer, form, figure, figcaption.
      // 5. Place all other images with placeholder URL: "https://placehold.co/600x400" and proper alt text.
      // 6. Inline simple SVG for icons; use SVG placeholder if complex.
      // 7. Preserve spacing (margins, paddings, gaps, positions) exactly.
      // 8. Fully responsive with desktop, tablet, and mobile styles.
      // 9. Accessibility: alt attributes, labels, proper heading hierarchy, accessible buttons/inputs.
      // 10. For framework "tailwind" or "bootstrap": use only framework classes; no custom CSS; JSON "css": "".
      // 11. For "custom": produce full custom CSS including fonts, colors, spacing, responsive media queries.
      // 12. Do not embed real images or assets from the image.
      // 13. Match font sizes, line-height, letter-spacing; use close web-safe/Google fonts if exact font unknown.
      // 14. Forms and interactive elements use realistic HTML and include focus/hover styles.

      // ADDITIONAL:
      // - Framework: ${selectedFramework === 'custom' ? 'Custom CSS' : selectedFramework}
      // - Extra instructions: ${customPrompt || "Keep the design clean, visually balanced, and match the image layout exactly."}
      // - Always use placeholder images; do not output real images.
      // - Background colors and background images must match the UI/UX design exactly.
      // `;

      const contents = [
        {
          role: "user",
          parts: [
            { text: prompt },
            {
              inlineData: {
                mimeType: uploadedImageMimeType,
                data: uploadedImageBase64,
              },
            },
          ],
        },
      ];

      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contents: contents }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      const rawText = data.candidates?.[0]?.content?.parts?.[0]?.text;

      if (!rawText) {
        throw new Error("No text was generated from the API response.");
      }

      const jsonStart = rawText.indexOf("{");
      const jsonEnd = rawText.lastIndexOf("}") + 1;
      const jsonString = rawText.substring(jsonStart, jsonEnd);

      const generatedCode = JSON.parse(jsonString);

      setGeneratedHTML(generatedCode.html);
      setGeneratedCSS(generatedCode.css);
      setSuccess("HTML and CSS generated successfully!");
    } catch (err) {
      console.error(err);
      setError(`Error: ${err.message}`);
      try {
        await axios.post(`https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/api/refund-credit`, {
          userEmail: user.email,
          amount: 1,
        });
        setCredits((prev) => prev + 1);
      } catch (refundErr) {
        console.error("Failed to refund credit:", refundErr);
      }
    } finally {
      setGenerating(false);
    }
  };

  const handleCopy = (code, type) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setSuccess(`${type} code copied to clipboard!`);
        setTimeout(() => setSuccess(""), 3000);
      })
      .catch((err) => {
        setError("Failed to copy code.");
        console.error("Copy failed", err);
      });
  };

  const handleDownload = (content, fileName, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setSuccess(`${fileName} downloaded successfully!`);
    setTimeout(() => setSuccess(""), 3000);
  };

  const downloadHTML = () => {
    handleDownload(generatedHTML, "index.html", "text/html");
  };

  const downloadCSS = () => {
    handleDownload(generatedCSS, "style.css", "text/css");
  };

  const renderPreview = () => {
    if (!generatedHTML) {
      return (
        <div className="text-center text-muted py-5">
          <p>Your generated UI will appear here.</p>
        </div>
      );
    }

    const getFullHTML = () => {
      let styleTag = '';
      if (selectedFramework === 'custom') {
        styleTag = `<style>${generatedCSS}</style>`;
      }

      let frameworkLink = '';
      if (selectedFramework === 'bootstrap') {
        frameworkLink = '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">';
      } else if (selectedFramework === 'tailwind') {
        frameworkLink = '<script src="https://cdn.tailwindcss.com"></script>';
      }

      return `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <title>
        </title>
        ${styleTag}
        ${frameworkLink}
      </head>
      <body>
        ${generatedHTML}
      </body>
      </html>
    `;
    };

    let iframeStyle = {
      width: "100%",
      height: "500px",
      border: "1px solid #ddd",
      borderRadius: "8px",
      transition: "width 0.3s ease-in-out, height 0.3s ease-in-out, transform 0.3s ease-in-out",
    };

    let scale = 1;

    if (currentView === 'tablet') {
      iframeStyle.width = '768px';
      iframeStyle.height = '1024px';
      scale = 0.65;
    } else if (currentView === 'mobile') {
      iframeStyle.width = '375px';
      iframeStyle.height = '667px';
      scale = 0.8;
    }

    iframeStyle.transform = `scale(${scale})`;
    iframeStyle.transformOrigin = 'top left';

    return (
      <div style={{ overflowX: 'auto' }}>
        <iframe
          title="UI Preview"
          srcDoc={getFullHTML()}
          style={iframeStyle}
        />
      </div>
    );
  };

  if (loadingAuth || loading || loadingKeys)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "4rem", height: "4rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  if (!user)
    return (
      <div className="container text-center py-5">
        <h2>Please log in to use the Image to HTML CSS AI tool</h2>
        <button
          className="btn btn-primary mt-3"
          onClick={() => (window.location.href = "/login")}
        >
          Go to Login
        </button>
      </div>
    );

  return (
    <div className="container py-5">
      <div className="row g-4">
        <div className="col-lg-12 mx-auto">
          <div className="card shadow-sm p-4">
            <h2 className="fw-bold m-0 mb-2" style={{ color: "#1a1a1a" }}>
              Image to <span style={{ color: "#e63946" }}>HTML & CSS AI</span>
            </h2>
            <h4>Credits: {credits}</h4>
            {credits < 1 && (
              <button
                className="enhance-btn"
                onClick={() => navigate("/user/select-package")}
              >
                Buy Now
              </button>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <div className="mb-3 mt-3">
              <label className="form-label">Upload UI/UX Image *</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageUpload}
              />
              {uploadedImageUrl && (
                <div className="mt-3 text-center">
                  <img
                    src={uploadedImageUrl}
                    alt="Uploaded Preview"
                    className="img-fluid rounded"
                    style={{ maxHeight: "200px" }}
                  />
                </div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Select Framework</label>
              <select
                className="form-select"
                value={selectedFramework}
                onChange={(e) => setSelectedFramework(e.target.value)}
              >
                <option value="tailwind">Tailwind CSS</option>
                <option value="bootstrap">Bootstrap</option>
                <option value="custom">Custom CSS</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Specific Instructions (Optional)
              </label>
              <textarea
                className="form-control"
                value={customPrompt}
                onChange={(e) => setCustomPrompt(e.target.value)}
                placeholder="e.g., Make the buttons red, use a dark theme, etc."
                rows={2}
              />
            </div>

            <div className="d-flex gap-2">
              <button
                className="btn btn-danger flex-fill"
                onClick={generateHTMLCSS}
                disabled={generating || !uploadedImageBase64}
              >
                {generating ? "Generating..." : "Generate HTML Code"}
              </button>
              <button
                className="btn btn-secondary flex-fill"
                onClick={() => {
                  setUploadedImageUrl("");
                  setUploadedImageBase64("");
                  setCustomPrompt("");
                  setGeneratedHTML("");
                  setGeneratedCSS("");
                  setError("");
                  setSuccess("");
                }}
                disabled={generating}
              >
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row g-4 mt-4">
        <div className="col-12">
          <div className="card shadow-sm p-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Live Preview</h5>
              <div className="d-flex gap-2">
                <button
                  className={`btn btn-sm ${currentView === 'desktop' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setCurrentView('desktop')}
                >
                  <i className="fas fa-desktop"></i>
                </button>
                <button
                  className={`btn btn-sm ${currentView === 'tablet' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setCurrentView('tablet')}
                >
                  <i className="fas fa-tablet-alt"></i>
                </button>
                <button
                  className={`btn btn-sm ${currentView === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setCurrentView('mobile')}
                >
                  <i className="fas fa-mobile-alt"></i>
                </button>
              </div>
            </div>
            {generating ? (
              <div className="text-center py-5">
                <div className="ai-generating-animation">
                  <div className="ai-icon mb-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-12 h-12"
                    >
                      <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
                    </svg>
                  </div>
                  <p>AI is generating your code...</p>
                  <div className="ai-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            ) : (
              renderPreview()
            )}
          </div>
        </div>

        {generatedHTML && (
          <div className="col-12 mt-4">
            <div className="card shadow-sm p-4">
              <h5>Generated Code</h5>
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="html-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#html-code"
                    type="button"
                    role="tab"
                    aria-controls="html-code"
                    aria-selected="true"
                  >
                    HTML
                  </button>
                </li>
                {selectedFramework === 'custom' && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="css-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#css-code"
                      type="button"
                      role="tab"
                      aria-controls="css-code"
                      aria-selected="false"
                    >
                      CSS
                    </button>
                  </li>
                )}
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="html-code"
                  role="tabpanel"
                  aria-labelledby="html-tab"
                >
                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => handleCopy(generatedHTML, "HTML")}
                    >
                      Copy HTML
                    </button>
                    <button
                      className="btn btn-sm btn-outline-success"
                      onClick={downloadHTML}
                    >
                      Download HTML
                    </button>
                  </div>
                  <pre className="p-3 bg-light rounded mt-3 overflow-auto">
                    <code>{generatedHTML}</code>
                  </pre>
                </div>
                {selectedFramework === 'custom' && (
                  <div
                    className="tab-pane fade"
                    id="css-code"
                    role="tabpanel"
                    aria-labelledby="css-tab"
                  >
                    <div className="d-flex justify-content-end gap-2 mt-3">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => handleCopy(generatedCSS, "CSS")}
                      >
                        Copy CSS
                      </button>
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={downloadCSS}
                      >
                        Download CSS
                      </button>
                    </div>
                    <pre className="p-3 bg-light rounded mt-3 overflow-auto">
                      <code>{generatedCSS}</code>
                    </pre>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .youtube-thumbnail-generator {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          font-family: Arial, sans-serif;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .credits-display {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .buy-credits-btn {
          background-color: #4285f4;
          color: white;
          border: none;
          padding: 5px 10px;
          border-radius: 4px;
          cursor: pointer;
        }

        .error-message {
          color: #d32f2f;
          background-color: #ffebee;
          padding: 10px;
          border-radius: 4px;
          margin-bottom: 15px;
        }

        .success-message {
          color: #388e3c;
          background-color: #e8f5e9;
          padding: 10px;
          border-radius: 4px;
          margin-bottom: 15px;
        }

        .main-content {
          display: flex;
          gap: 30px;
          margin-bottom: 40px;
        }

        .form-section {
          flex: 1;
          background-color: #f9f9f9;
          padding: 20px;
          border-radius: 8px;
        }

        .form-group {
          margin-bottom: 15px;
        }

        label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }

        input[type="text"],
        select,
        textarea {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          box-sizing: border-box;
        }

        .enhance-btn {
          background-color: #fbbc05;
          color: #333;
          border: none;
          padding: 8px 12px;
          border-radius: 4px;
          cursor: pointer;
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .enhance-btn:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }

        .form-actions {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }

        .generate-btn,
        .reset-btn {
          padding: 10px 15px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .generate-btn {
          background-color: #ea4335;
          color: white;
          flex: 1;
        }

        .generate-btn:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }

        .reset-btn {
          background-color: #f1f1f1;
          color: #333;
        }

        .loading-spinner {
          display: inline-block;
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s ease-in-out infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        .preview-section {
          flex: 1;
          background-color: #f9f9f9;
          padding: 20px;
          border-radius: 8px;
        }

        .preview-container {
          margin-bottom: 20px;
        }

        .generated-thumbnails {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .thumbnail-item {
          text-align: center;
        }

        .thumbnail-image {
          max-width: 100%;
          border-radius: 4px;
          margin-bottom: 10px;
        }

        .download-btn {
          background-color: #34a853;
          color: white;
          border: none;
          padding: 8px 15px;
          border-radius: 4px;
          cursor: pointer;
        }

        .preview-placeholder {
          text-align: center;
          padding: 20px;
        }

        .thumbnail-frame {
          width: 100%;
          aspect-ratio: 16/9;
          background-color: #333;
          border-radius: 4px;
          margin-top: 15px;
          position: relative;
          overflow: hidden;
        }

        .thumbnail-content {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: white;
          padding: 20px;
          box-sizing: border-box;
        }

        .thumbnail-title {
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          color: #ff0000;
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
        }

        .preview-info {
          margin-top: 20px;
        }

        .prompt-preview {
          background-color: #e0e0e0;
          padding: 10px;
          border-radius: 4px;
          font-size: 14px;
          max-height: 150px;
          overflow-y: auto;
          word-wrap: break-word;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          font-size: 24px;
        }

        .preview-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          text-align: center;
        }

        .ai-generating-animation {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
        }

        .ai-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #4285f4, #34a853);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: pulse 2s infinite;
        }

        .ai-icon svg {
          color: white;
          width: 48px;
          height: 48px;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(66, 133, 244, 0.7);
          }
          70% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(66, 133, 244, 0);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(66, 133, 244, 0);
          }
        }

        .ai-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }

        .ai-text p {
          font-size: 18px;
          font-weight: 500;
          color: #333;
        }

        .ai-dots {
          display: flex;
          gap: 4px;
        }

        .ai-dots span {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #4285f4;
          animation: bounce 1.4s infinite ease-in-out both;
        }

        .ai-dots span:nth-child(1) {
          animation-delay: -0.32s;
        }

        .ai-dots span:nth-child(2) {
          animation-delay: -0.16s;
        }

        @keyframes bounce {
          0%,
          80%,
          100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }

        @media (max-width: 768px) {
          .main-content {
            flex-direction: column;
          }

          .youtube-thumbnail-generator {
            padding: 10px;
          }

          .header {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          .ai-generating-animation {
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default ImageToHTMLCSSAI;